module.exports = __webpack_public_path__ + "img/technicalSupportRight.18f0f251.svg";